import * as Sentry from '@sentry/react';
import React from 'react';
import {CurrentUserData} from 'security';

export * from './datadog';


const lookLikeApolloNetworkError = (error: any): boolean => !!error?.networkError;
const isNetworkError = (event: Sentry.Event): boolean => {
    if (event.exception && event.exception.values && event.exception.values.length === 1) {
        return lookLikeApolloNetworkError(event.exception.values[0]);
    }
    return false;
};


export const captureError = (error: Error, errorInfo: React.ErrorInfo) => {
    if (isSentryEnabled()) {
        Sentry.withScope((scope) => {
            scope.setExtras({
                errorInfo
            });
            Sentry.captureException(error);
        });
    }
};
export const captureMessage = (message: string) => {
    if (isSentryEnabled()) {
        Sentry.withScope((scope) => {
            Sentry.captureMessage(message);
        });
    }
};


export const setCurrentUserForSentry = (user: CurrentUserData | null) => Sentry.setUser(user ? {
    id: user.guid,
    role: user.role,
} : null);

const isSentryEnabled = () => !!process.env.REACT_APP_SENTRY_DSN;
export const initSentry = () => {
    if (isSentryEnabled()) {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local',
            release: process.env.REACT_APP_SENTRY_RELEASE || 'unknown',
            beforeSend: (event: Sentry.Event): Sentry.Event | null => {
                if (isNetworkError(event)) {
                    return null;
                }
                return event;
            },
        });
        Sentry.setTag('server_name', 'provider');
    }
}
